import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import RoleActivity from './RoleActivity'

interface RoleActivityModalProps {
  show: boolean
  roleName: string
  roleCode?: string
  onHide: () => void
}

const RoleActivityModal: React.FC<RoleActivityModalProps> = ({
  show,
  roleName,
  roleCode,
  onHide,
}) => {
  const { t } = useTranslation(['translation'])
  const [applicationName, setApplicationName] = useState('')

  return (
    <Modal
      size="lg"
      backdrop="static"
      show={show}
      onHide={onHide}
      scrollable={true}
    >
      <Modal.Header closeButton>
        <div className="d-flex flex-column">
          <Modal.Title id="role-activity-modal-title">
            {`${t('userRoles.role')}: ${roleName}`}
          </Modal.Title>
          {applicationName && (
            <small className="text-muted mt-1">
              <strong>{t('user_management.application')}:</strong>{' '}
              {applicationName}
            </small>
          )}
        </div>
      </Modal.Header>
      <Modal.Body>
        <RoleActivity
          roleCode={roleCode}
          onApplicationName={setApplicationName}
        />
      </Modal.Body>
    </Modal>
  )
}

export default RoleActivityModal
